import moment from 'moment'

export const isHolidays = ({ date, holidays }) =>
  holidays.some(d => moment(d.date).isSame(date))
